import { createApi } from '@reduxjs/toolkit/query/react';

import apiBaseQuery from './axiosBaseQuery';

export const USERS_API_REDUCER_KEY = 'usersApi';

export const usersApi = createApi({
  reducerPath: USERS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ['user'],
  endpoints: (builder) => ({
    getMe: builder.query({
      query: () => ({
        url: 'users/me/'
      }),
      providesTags: ['user'],
    }),
    getUsers: builder.query({
      query: ({ page, q, limit }) => ({
        url: `users?page=${page}&q=${q}&limit=${limit}`
      }),
      providesTags: ['user'],
    }),
    getUser: builder.query({
      query: (id) => ({
        url: `users/${id}`
      }),
      providesTags: ['user'],
    }),
    updateUser: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `users/${id}/`,
        method: 'PUT',
        body: rest,
      }),
      invalidatesTags: ['user']
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `users/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['user']
    }),
    changePassword: builder.mutation({
      query: (body) => ({
        url: `users/me/change-password`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['user']
    }),
  })
});

export const { useDeleteUserMutation, useGetMeQuery, useGetUserQuery, useGetUsersQuery, useUpdateUserMutation, useChangePasswordMutation } = usersApi;